import { Injectable } from '@angular/core';

import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlSpanish extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Elementos por página:';
  override nextPageLabel     = 'Siguiente página';
  override previousPageLabel = 'Página anterior';
  override firstPageLabel    = 'Primera página';
  override lastPageLabel     = 'Última página';

  private ofPageLabel: string = 'de';
  private falsyOfPageLabel: string = `0 ${this.ofPageLabel}`;

  override getRangeLabel = ( page: number, pageSize: number, length: number ) => {
    if ( length === 0 || pageSize === 0 )  return `${this.falsyOfPageLabel} ${length}`;
    length = Math.max( length, 0 );

    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min( startIndex + pageSize, length ) : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} ${this.ofPageLabel} ${length}`;
  };
}